// import { createHashHistory as history } from 'history';
import { createBrowserHistory as history } from 'history';

export default history();